import { Component, h, useMemo, WriteOnlyRef } from "@lukekaalim/act";
import { html } from "@lukekaalim/act-web";
import { UserState } from "../../defs/userState";

import classes from './index.module.css';
import { cyrb64 } from "@kosmod/kit";
import { Account, AccountDescription } from "../../defs";

export type ProfileCircleProps = {
  name: string,
  color?: string,
  colorHash?: string,

  profileCircleRef?: WriteOnlyRef<HTMLElement>
}

export const ProfileCircle: Component<ProfileCircleProps> = ({ name, color, colorHash, profileCircleRef }) => {
  const finalColor = useMemo(() => {
    if (color)
      return color;
    if (colorHash) {
      const hash = cyrb64(colorHash);
      return `hsl(${(hash / Number.MAX_SAFE_INTEGER) * 360}, 50%, 50%)`
    }
    return 'grey';
  }, [color, colorHash])

  return h(html.div, { className: classes.profileCircleContainer, ref: profileCircleRef }, [
    h(html.div, { className: classes.profileCircle }, [
      h(html.div, { style: { backgroundColor: finalColor }, className: classes.profileCirclePreview },
        h(html.span, {}, name[0].toLocaleUpperCase())
      )
    ])
  ])
};
